import { apiRequest } from './apiClient';

export type NotificationChannelPrefs = {
  push: boolean;
  email: boolean;
  sms: boolean;
};

export type NotificationTypePrefs = {
  spend_alerts: boolean;
  insight_ready: boolean;
  household: boolean;
};

export type NotificationPreferences = {
  channels: NotificationChannelPrefs;
  types: NotificationTypePrefs;
};

export type ChannelReadiness = {
  push: { available: boolean; detail: string };
  email: { available: boolean; detail: string; value?: string };
  sms: { available: boolean; detail: string; value?: string };
};

export type NotificationPreferencesResponse = {
  preferences: NotificationPreferences;
  email: string | null;
  phoneNumber: string | null;
  channels: ChannelReadiness;
};

export async function getNotificationPreferences(): Promise<NotificationPreferencesResponse> {
  return apiRequest('/notifications/preferences');
}

export async function putNotificationPreferences(input: {
  channels?: Partial<NotificationChannelPrefs>;
  types?: Partial<NotificationTypePrefs>;
  emailAddress?: string;
  phoneNumber?: string;
  /** Flat aliases used by spend-alert UI */
  push?: boolean;
  email?: boolean;
  sms?: boolean;
}): Promise<NotificationPreferencesResponse> {
  return apiRequest('/notifications/preferences', {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}
